export default __webpack_public_path__ + "media/src/assets/images/manThinking-67ee7aa5ced639bdaf0a1a9f2363b0d6.svg";